<!-- 积分明细 -->
 <template>
   <div>
    <div class="page-form" v-if="isShow">
        <PageBack :title="title" />
        <div class="custom-table2">
            <div class="size20 center mg-b-10 bold">{{ pubTitle }}</div>
            <div class="flex-row-1">
                <el-table :data="firstTableData" 
                v-if="firstTableData.length > 0"
                :row-class-name="tableRowClassName"
                :cell-class-name="tableCellStyle"
                class="custom-table"
                style="width: 100%" border>
                <el-table-column   
                    v-for="(item, index) in dynamicHeaders"
                    :key="index"
                    :prop="item.prop"
                    :label="item.label" 
                    align="center">
                </el-table-column>
            </el-table>
            <el-table :data="secondTableData" 
                v-if="secondTableData.length > 0"
                :row-class-name="tableRowClassName"
                :cell-class-name="tableCellStyle"
                class="custom-table"
                style="width: 100%;margin-left: 15px;" border>
                <el-table-column   
                    v-for="(item, index) in dynamicHeaders"
                    :key="index"
                    :prop="item.prop"
                    :label="item.label" 
                    align="center">
                </el-table-column>
            </el-table>
            </div>
        </div>
    </div>
   </div>
 </template>
 
 <script>
import PageBack from '@/components/PageHeader'
 export default {
    components:{
        PageBack
    },
    data(){
        return{
            isShow: false,
            tableData:[],
            firstTableData: [],
            secondTableData: [],
            tableHeaders: [
                {label: '排名', prop: 'rank'},                
                {label: '名称', prop: 'username'},
                {label: '搭档', prop: 'partername'},
                {label: '积分', prop: 'score'},    
                {label: '角色', prop: 'rolename'},              
                // {label: '手机号', prop: 'phone'},
            ],
            dynamicHeaders:[],
            pubTitle: ''
        }
    },
    computed:{
        title(){
            return this.$route.meta.title
        }, 
        publishId(){
            return this.$route.query.id
        } 
    },
    created(){

    },
    mounted(){
        this.initData()
        if(this.publishId){
            this.getQuery()
        }
    },
    methods:{
        getQuery(){
            let params = {
                opcode: this.$code.PublishQuery,
                i_serial_mark: this.publishId,
                c_status: '',
                v_type: '',
                v_theme: '',
                start_date: '',
                end_date: '',
                pagesize: 10,
                page: 1,
            }
            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable[0]
                    this.pubTitle = result['主题']
                }
            })
        },
        initData(){
            let params = {
                opcode: this.$code.SetGradeQuery,
                i_serial_mark: this.publishId
            }
            this.$api._requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    let result = res.Data.DataTable 
                    if(result.length > 0){
                        this.tableData = result.map(item=>{                    
                            return{                            
                                rank: item['赛事角色']=== '赛事选手' ? item['名次']: '',
                                username: item['姓名'],
                                partername: item['搭档姓名'],
                                score: item['积分'],
                                phone: item['手机号'],    
                                rolename: item['赛事角色'], 
                            }
                        })    
                        this.isShow = true
                        // 获取所有唯一的字段名
                        const fields = Array.from(new Set(this.tableData.flatMap(Object.keys)));
                        // 过滤出至少有一个非空值的字段
                        let filterArrNew= fields.filter(field => this.tableData.some(row => row[field] !== null && row[field] !== undefined && row[field] !== ''));
                        this.dynamicHeaders = this.tableHeaders.filter(i=>filterArrNew.includes(i.prop))

                        let  playerArr  = JSON.parse(JSON.stringify(this.tableData))
                        if(playerArr.length > 10){
                            const splitSize = Math.round(playerArr.length / 2); 
                            this.firstTableData = playerArr.slice(0, splitSize);  
                            this.secondTableData = playerArr.slice(splitSize);  
                        }else{
                            this.firstTableData = playerArr
                            this.secondTableData = []
                        }
                    }else{
                        this.tableData = []
                        this.firstTableData = []
                        this.secondTableData = []
                        this.$message.error('暂无成绩')
                    }                               
                }else{
                    this.$message.error(res.Message)
                }
            })
        },
        tableRowClassName({row, rowIndex}){
            // 选手以外的角色一种颜色
            if(row.rolename !== '赛事选手'){
                return 'green-row'
            }
            // 前三名不同的颜色
            if(row.rank === 1){
                return 'gold-row'
            }else if(row.rank === 2){
                return  'silver-row'
            }else if(row.rank === 3){
                return  'brown-row'
            }
        },
        tableCellStyle({row,column, rowIndex}){
            if(column.property === 'score'){
                 return 'red-row'
            }
        }
    },
 }
 </script>
 
 <style lang="scss" scoped>
  @import '@/assets/css/style.scss';
.custom-table >>> .el-table__cell{
    font-size: 20px;
    padding: 0 !important;
    color:#000
}
.el-table >>> .green-row{
    background-color: #bbffbb
}
.el-table >>> .red-row{
    // color: red;
    // font-size: 20px;
}
.custom-table >>> .gold-row{
    background-color: #FFD700;
}
.custom-table >>> .silver-row{
    background-color: #C0C0C0;
}
.custom-table >>> .brown-row{
    background-color: #CD7F32;
}
 </style>


// WEBPACK FOOTER //
// src/views/playerScore/gradeQuery.vue